module.exports = __webpack_public_path__ + "static/img/desc.163caef8.png";